export default __webpack_public_path__ + "static/media/empty-cart.817a8b15.png";